import ApiGet from "../../../../../api-controller-mod/api-serv/get-api/getApi";
import ApiPatch from "../../../../../api-controller-mod/api-serv/post-api/patchApi";
import { MockSetGroup } from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier.type";

export const MockSetDig: MockSetGroup[] = [
    {
        id: 1,
        title: "Asset Information",
        description: "Configure media asset requirements and policies",
        items: [
            { id: 1, title: "Require media name", description: "Enforce media files to have a descriptive name", controlType: "toggle" },
        ],
    },
    {
        id: 2,
        title: "Asset Policy",
        description: "Configure media asset requirements and policies",
        items: [
            { id: 1, title: "Required confirmation for deletion", description: "Enable users to delete media assets from the library", controlType: "toggle" },
            { id: 2, title: "Media deletion", description: "Enable users to delete media assets from the library", controlType: "toggle" },
            { id: 3, title: "Prevent deletion", description: "Prevent deletion if the media is in use", controlType: "toggle" },
            { id: 4, title: "Allow select from media", description: "Master control for media deletion across the platform", controlType: "toggle" },
        ],
    },
    {
        id: 3,
        title: "Asset Caching",
        description: "Configure caching and AI processing options",
        items: [
            { id: 1, title: "Device upload", description: "Enable user processing and analysis for uploaded images", controlType: "toggle" },
            {
                id: 2,
                title: "Max media size (mb)",
                description: "Maximum file size allowed per contact",
                controlType: "input",
                inputConfig: { type: "text", width: 72, placeholder: "10 MB", validate: true },
            },
            // { id: 3, title: "Media selection", description: "Enable media selection from library", controlType: "toggle" },
        ],
    },
];

export type MediaSettingsResponse = {
  success: boolean;
  requestId: string;
  data: {
    module: string;
    settings: {
      delete: {
        enabled: boolean;
        confirm: { enabled: boolean };
        used: { enabled: boolean };
      };
      alt: { required: boolean; allowEmpty: boolean };
      name: { required: boolean };
      asset: { use: { enabled: boolean } };
      upload: { personal: { enabled: boolean }; maxFileSizeMb: number };
    };
  };
};

export const getMediaSettings = () => ApiGet<MediaSettingsResponse>("/api/v1/settings/media");

export type MediaUpdateBody = {
  delete?: {
    enabled?: boolean;
    confirm?: { enabled?: boolean };
    used?: { enabled?: boolean };
  };

  name?: { required?: boolean };

  alt?: {
    required?: boolean;
    allowEmpty?: boolean;
  };

  upload?: {
    personal?: { enabled?: boolean };
    maxFileSizeMb?: number;
  };

  asset?: {
    use?: { enabled?: boolean };
  };
};

export const patchMediaSettings = (body: MediaUpdateBody) => ApiPatch("/api/v1/settings/media/update", body);